import React from "react";
import {Card, List, Typography, DatePicker, Popover} from "antd";
import moment from "moment";
import locale from "antd/es/date-picker/locale/tr_TR";
import {isNumber} from "lodash";
import {ListHeader, ListItemContainer} from "./CourierWalletPaymentsList.styles";
import JSONInput from "react-json-editor-ajrm";
import {InfoCircleOutlined} from "@ant-design/icons";
const {Text} = Typography;
const {RangePicker} = DatePicker;

export const CourierWalletPaymentsList = ({
    payments,
    onItemSelect,
    selectedItem,
    onDateRangeChange,
    loading,
    selectedDateRange
}) => {
    return (
        <Card
            loading={loading}
            title={
                <ListHeader>
                    <span>Ödemeler</span>
                    <RangePicker
                        locale={locale}
                        format="DD/MM/YYYY"
                        onChange={onDateRangeChange}
                        value={selectedDateRange}
                    />
                </ListHeader>
            }
            bodyStyle={{padding: "0px"}}
        >
            <List
                dataSource={payments || []}
                style={{height: "500px", overflow: "auto", padding: "24px"}}
                renderItem={item => {
                    const isSelected =
                        selectedItem && selectedItem?._id?.toString() === item._id.toString();

                    return (
                        <List.Item
                            style={{
                                padding: "24px",
                                cursor: "pointer",
                                backgroundColor: isSelected ? "#f0f0f0" : "transparent"
                            }}
                            onClick={() => onItemSelect(item._id)}
                        >
                            <ListItemContainer>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Text>
                                        <b>Ödeme ID</b> : {item?.paymentId}{" "}
                                        <Popover
                                            content={
                                                <JSONInput
                                                    id="paymentInvoiceJSON"
                                                    placeholder={item}
                                                    theme="dark_mitsuketa_tribute"
                                                    width="auto"
                                                    height="auto"
                                                    viewOnly={true}
                                                    confirmGood={false}
                                                />
                                            }
                                        >
                                            <InfoCircleOutlined />
                                        </Popover>
                                    </Text>
                                    <Text>
                                        <b>Durum</b> : {item?.status}
                                    </Text>
                                    <Text>
                                        <b>Oluşturulma Tarihi</b> :{" "}
                                        {item?.createdAt
                                            ? moment(item.createdAt).format("DD MMMM YYYY HH:mm")
                                            : ""}
                                    </Text>
                                </div>
                                <Text strong type={item.amount >= 0 ? "success" : "danger"}>
                                    {isNumber(item?.amount)
                                        ? item?.amount?.toLocaleString("tr-TR", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                          })
                                        : "-"}{" "}
                                    ₺
                                </Text>
                            </ListItemContainer>
                        </List.Item>
                    );
                }}
            />
        </Card>
    );
};
